import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';

import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import * as columnFormatters from '../../../../../../components/SelectProduct/List/column-formatters';
import Numeric from '../../../../../../components/Numeric';
import SelectedProduct from '../../../../../../components/SelectProduct';
import DialogBox from '../../../../../../components/DialogBox';

import css from './style.module.css';

export const URL = '/products';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return { products: action.payload };
    case 'insert':
      return { products: [...state.products, ...action.payload] };
    case 'remove':
      return {
        products: state.products.filter((item) => {
          if (item.productCode !== action.payload) return item;
        }),
      };
    case 'updatecount':
      return {
        products: state.products.map((item) => {
          if (item.productCode === action.payload.id) {
            const updatedItem = {
              ...item,
              count: Number(action.payload.newCount),
            };

            return updatedItem;
          }

          return item;
        }),
      };
    default:
      throw new Error();
  }
}

export default function SubProducts(props) {
  const [state, dispatch] = useReducer(reducer, { products: [] });
  const { product, saveSubProducts } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [openSelectProducts, setOpenSelectProducts] = useState(false);
  const [openConfirmRemoveItem, setOpenConfirmRemoveItem] = useState(false);
  const [loading, setLoading] = useState(false);

  const [toRemoveItem, setToRemoveItem] = useState();

  //console.log('ORDERITEMS.Order: ', order);
  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    /*     {
      dataField: 'productCode',
      text: 'Code',
      sort: false,
      formatter: columnFormatters.IdColumnFormatter,
    }, */
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'productPricePer',
      text: 'Price',
      sort: false,
      formatter: ProductPriceColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'cost',
      text: 'Cost',
      sort: false,
      formatter: ProductPriceColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '70px',
      },
    },
    {
      dataField: 'count',
      text: 'QTY in SET',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      formatter: ProductQTYColumnFormatter,
      style: {
        minWidth: '60px',
        width: '70px',
      },
    },
    {
      dataField: 'action',
      text: '',
      formatter: ActionsColumnFormatter,

      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '50px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(URL, product.productCode, { headers: { action: 'getsubproducts' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('SubProducts: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({ type: 'init', payload: response.data.data });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [product]);

  useEffect(() => {
    //console.log('RefreshedItems', state);
    setTotalCount(state.products.length);
  }, [state]);

  const save = () => {
    setLoading(true);
    /*     let codeList = [];
    for (let i = 0; i < state.products.length; i++) {
      codeList.push(state.products[i].productCode);
    } */
    console.log('saveSubProducts', state.products);
    axios
      .post(
        URL,
        { productCode: product.productCode, subProducts: state.products },
        { headers: { action: 'setsubproducts' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
            setError('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            //saveSubProducts(state.products);
            break;
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            //saveSubProducts(state.products);
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const onItemsAddClick = () => {
    setOpenSelectProducts(true);
  };

  const addSelectedItems = (selectedItems) => {
    //console.log('SelectedRows to add: ', selectedItems);
    let temp = [];
    for (let i = 0; i < selectedItems.length; i++) {
      let t = selectedItems[i];
      temp.push({
        productCode: t.productCode,
        name: t.name,
        icon: t.icon,
        price: t.price,
        cost: t.cost,
        count: 1,
      });
    }

    dispatch({ type: 'insert', payload: temp });
  };

  const removeItem = (item) => {
    // confirm
    setToRemoveItem(item);
    setOpenConfirmRemoveItem(true);
  };
  const remove = () => {
    //console.log('remove', productCode);

    dispatch({ type: 'remove', payload: toRemoveItem.productCode });
  };

  const setCount = (id, newCount) => {
    dispatch({ type: 'updatecount', payload: { id, newCount } });
  };

  function handleToggleCompleteQuantity(id, newCount) {
    dispatch({ type: 'updatecount', payload: { id, newCount } });
  }
  const setQuantityVal = (id, quantity) => {
    handleToggleCompleteQuantity(id, quantity);
  };

  function ProductPriceColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`subproductPrice_${row.productCode}`}
        name='price'
        value={cellContent}
        className='form-control form-control-sm'
        negative={false}
        postfix='₮'
        disabled={true}
      />
    );
  }

  function ProductQTYColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`productQuantity_${row.productCode}`}
        name='productQuantity'
        value={cellContent}
        onBlur={(e) => {
          setQuantityVal(row.productCode, e);
        }}
        className='form-control form-control-sm'
        negative={false}
        type='number'
        decimalScale='0'
        fixedDecimalScale={false}
      />
    );
  }

  function ActionsColumnFormatter(cellContent, row, rowIndex) {
    return (
      <>
        <a
          title='Бүтээгдэхүүний сонголт устгах'
          className='btn btn-icon btn-light btn-hover-danger btn-sm'
          onClick={() => removeItem(row)}
        >
          <span className='svg-icon svg-icon-md svg-icon-danger'>
            <SVG src={toAbsoluteUrl('/media/svg/icons/General/Trash.svg')} />
          </span>
        </a>
      </>
    );
  }

  const generateExistingProducts = () => {
    let arr = [...state.products];
    arr.push({ productCode: product.productCode });
    return arr;
  };

  return (
    <div className={css.box}>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}
      {openSelectProducts && (
        <SelectedProduct
          openSelectProducts={openSelectProducts}
          setOpenSelectProducts={setOpenSelectProducts}
          addSelectedItems={addSelectedItems}
          //existingItems={entities}
          existingItems={generateExistingProducts()}
        />
      )}
      {toRemoveItem && (
        <DialogBox
          openDialog={openConfirmRemoveItem}
          setOpenDialog={setOpenConfirmRemoveItem}
          icon='question'
          iconColor='danger'
          title='Бүтээгдэхүүн хасах'
          text={`${toRemoveItem.name} #${toRemoveItem.productCode}  гэсэн сонгосон дэд бүтээгдэхүүн устгахдаа итгэлтэй байна уу?'`}
          buttonOk={false}
          buttonYes={true}
          buttonNo={true}
          onConfirm={remove}
        ></DialogBox>
      )}
      <Card id='subProductCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Дэд бүтээгдэхүүн - ${totalCount}`}>
          <CardHeaderToolbar>
            <>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={onItemsAddClick}
              >
                <FormattedMessage id='GENERAL.BUTTON.ADD' />
                {loading && (
                  <span
                    id='subProductsAdd'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
              <> </>
              <button
                type='button'
                className='btn btn-info ml-2'
                onClick={save}
              >
                <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                {loading && (
                  <span
                    id='subProductSave'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
            </>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/*           {items &&
            items.map((item) => (
              <OrderItem key={`OrderItem${item.productCode}`} value={item} />
            ))} */}
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={false}
            local
            keyField='productCode'
            //data={entities === null ? [] : entities}
            data={state.products === null ? [] : state.products}
            columns={columns}
            //onTableChange={getHandlerTableChange(setQueryParams)}
            /*  selectRow={getSelectRow({
              entities,
              ids,
              setIds,
            })} */
          >
            {/*  <PleaseWaitMessage entities={entities} />
            <NoRecordsFoundMessage entities={entities} /> */}
            <PleaseWaitMessage entities={state.products} />
            <NoRecordsFoundMessage entities={state.products} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
